import { createFileRoute } from "@tanstack/react-router";
import { HistoryTab } from "../-agents/history-tab";

export const Route = createFileRoute("/agents/figma-convert/history")({
  component: HistoryTab,
});
